routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.mainMenu', {
      url: "panel-de-control/main-menu",
      template: `<main-menu sh-ctrl="shCtrl"></main-menu>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/main-menu/main-menu.config.js
 **/